module.exports = __webpack_public_path__ + "static/img/celoscope-detail-16.2a910f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-16.jpg
// module id = vgQB
// module chunks = 51